<div *ngIf="!!customer">
  <div class="row mb-4">
    <div class="col d-flex flex-direction-row justify-content-between">
      <h3>{{ customer.name }}</h3>
      <lib-action-btn [item]="customer" [config]="configService"></lib-action-btn>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <lib-gung-tabset
        #ngbTab="gungTabset"
        (tabChange)="tabChanged($event)"
        [activeId]="activeIdString"
        orientation="vertical"
        *ngIf="!!customer"
        [collapsible]="true"
        [sidebarLabel]="(isSalesOrAdmin ? 'CUSTOMER' : 'MY_ACCOUNT') | translate"
      >
        @for (tab of customerDetailsTabs; track tab.id) {
          <lib-gung-tab [id]="tab.id" [icon]="tab.icon" title="{{ tab.name | translate }}">
            <ng-template libGungTabTitle>
              <div class="tab-title">
                <i *ngIf="tab.icon" [class]="tab.icon"></i>
                <span>{{ tab.name | translate }}</span>
              </div>
            </ng-template>
            <ng-template libGungTabContent>
              <div class="row">
                <div class="col-12">
                  <ng-container *ngComponentOutlet="tab.component; inputs: tab.componentInputParams"></ng-container>
                </div>
              </div>
            </ng-template>
          </lib-gung-tab>
        }
      </lib-gung-tabset>
    </div>
  </div>
</div>
